import cnsRepository from './cnsRepository'
import parametrizacaoRepository from './parametrizacaoRepository'

export default baseUrl => {
    return {
        cns: cnsRepository(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
    }
}